<template>
    <tr :class="{'station-row': isStation, 'machines-row': !isStation }"  :id="actualRow.key" @click="rowClicked" >
        <td :colspan="!isStation && key=='name'?2:1"  v-for="(value, key) in formattedRowInfo(row.key)" >
            <template v-if="key=='state'">
                <div :class="['clicable-relative',stateClass]" :title="stateTitle" @click="toggleTooltip">
                    <template v-if="showTooltip">
                        <div :class="['state-tooltip', 'state-tooltip-' + stateClass]">
                            <div class="state-tooltip-row">
                                <span class="state-tooltip-row-left-span">
                                    {{ stateTitle }} 
                                </span>
                            </div>
                        </div>
                    </template>
                </div>
            </template>
            <template v-else>
                <div>{{ value }}</div>
            </template>
        </td>
    </tr>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {EchoUtils, EchoChannels, EchoEvents} from "../../common/echo";

export default {
    name: "CustomRow",
    props:{
        row: Object
    },
    data(){
        return {
            showTooltip: false,
        }
    },
    mounted() {},
    methods:{
        ...mapActions('order_reference_view',['createRow', 'updateRow']),
        rowClicked(){
            if(this.isStation){
                let rowsToChange =  this.rows.filter(r => r.station_id == this.actualRow?.id)
                rowsToChange.forEach(r => {
                    this.updateRow({ row: {...r, collapsed: !r.collapsed} })
                })
            }
        },
        formatPackagingFormat(format){ // CAJA -> Cajas
            let firstCharacter  = format.substring(0,1),
                restToLower     = format.substring(1, format.length).toLowerCase()

            return firstCharacter + restToLower + 's';
        },
        incrementMachineProducedQuantity(machine){
            machine.data.ok_quantity++;
        },
        prepareEchoListeners(){
            if(!this.isMachine || this.actualRow.data.is_order_finished) return;
            window.Echo.private(EchoChannels.PRIVATE.MACHINES(this.row.data.id))
                .listen(EchoEvents.UNIT_COUNTING_DATA_RECEIVED_EVENT, (data) => {
                    this.unitCountingDataReceivedEventHandler(data.data);
                })
                .listen(EchoEvents.CONTROL_WEIGHT_DATA_RECEIVED_EVENT, (data) => {
                    this.controlWeightDataReceivedEventHandler();
                })
        },
        unitCountingDataReceivedEventHandler(data){
            let machineData = this.actualRow.data;
            if(!machineData) return;
            if(machineData.is_order_finished) return;
            let valueDifference = parseFloat(data.value - machineData.last_unit_value);
            if(machineData.last_unit_value == 0) valueDifference = 1;
            this.unitCountingMachineChangesHandler(data, machineData, valueDifference);
            this.stationChangesHandler(machineData, valueDifference);
        },
        controlWeightDataReceivedEventHandler(){
            let machineData = this.actualRow.data;
            if(!machineData) return;
            if(machineData.is_order_finished) return;
            this.controlWeightMachineChangesHandler(machineData);
            this.stationChangesHandler(machineData, 0);
        },
        controlWeightMachineChangesHandler(machineData){
            machineData.ok_quantity++;
            machineData.completed_percentage = `${parseFloat((machineData.ok_quantity / machineData.parent_partial_quantity) * 100).toFixed(2)}%`;
            if(parseFloat(machineData.completed_percentage).toFixed(2) > 100)
                machineData.completed_percentage = '100%';

            machineData.total_stops_seconds -= machineData.seconds_per_unit;
            machineData.total_stops_time = this.secondsToHumanTimeInLocale(machineData.total_stops_seconds);
            if( ( machineData.delayed_quantity - 1 ) >= 0 )
                machineData.delayed_quantity--;
        },
        unitCountingMachineChangesHandler(data, machineData, valueDifference){
            let newStatus = data.status;
            if(valueDifference > 0) {
                machineData.ok_quantity = parseFloat(machineData.ok_quantity) + valueDifference;
                machineData.completed_percentage = `${parseFloat((machineData.ok_quantity / machineData.parent_partial_quantity) * 100).toFixed(2)}%`;
                if(parseFloat(machineData.completed_percentage).toFixed(2) > 100)
                    machineData.completed_percentage = '100%';
                machineData.total_stops_seconds -= (valueDifference * machineData.seconds_per_unit);
                console.log('total_stops_seconds', machineData.total_stops_seconds, 'valueDifference', valueDifference, 'secondsPerUnit', machineData.secondsPerUnit);
                machineData.total_stops_time = this.secondsToHumanTimeInLocale(machineData.total_stops_seconds);
                console.log('total_stops_time', machineData.total_stops_time);
                if(machineData.delayed_quantity - valueDifference >= 0)
                    machineData.delayed_quantity = machineData.delayed_quantity - valueDifference;
                else
                    machineData.delayed_quantity = 0;
                machineData.last_unit_value = data.value;
                newStatus = 2;
            }
            machineData.equipment_state_id = newStatus;
        },
        stationChangesHandler(machineData, valueDifference){
            let stationData = this.parentRow.data;
            let secondsPerUnit = stationData.seconds_per_unit;
            if(machineData.does_value_increment_by_one)
            {
                stationData.ok_quantity++;
                stationData.completed_percentage = `${parseFloat((stationData.ok_quantity / stationData.parent_partial_quantity) * 100).toFixed(2)}%`;
                stationData.total_stops_seconds -= secondsPerUnit;
                stationData.total_stops_time = this.secondsToHumanTimeInLocale(stationData.total_stops_seconds);
                if( ( stationData.delayed_quantity - 1 ) >= 0 )
                    stationData.delayed_quantity--;
            } 
            else 
            {
                if(valueDifference > 0) {
                    stationData.ok_quantity = parseFloat(stationData.ok_quantity) + valueDifference;
                    stationData.completed_percentage = `${parseFloat((stationData.ok_quantity / stationData.parent_partial_quantity) * 100).toFixed(2)}%`;
                    stationData.total_stops_seconds -= (valueDifference * secondsPerUnit);
                    stationData.total_stops_time = this.secondsToHumanTimeInLocale(stationData.total_stops_seconds);
                    if(stationData.delayed_quantity - valueDifference >= 0)
                        stationData.delayed_quantity = stationData.delayed_quantity - valueDifference;
                    else
                        stationData.delayed_quantity = 0;
                }
            }
            this.stationEquipmentStateByMachines();
        },
        stationEquipmentStateByMachines() {
            let stationData = this.parentRow.data;
            if (!stationData) return;
            let machines = this.rows.filter(r => r.parent_key == stationData.table_key && r.type == 'machine');
            let hasState0 = false;
            let hasState1 = false;
            let hasState2 = false;
            machines.forEach(m => {
                let machine = m.data;
                if (machine.equipment_state_id === 0) {
                    hasState0 = true;
                }           
                if (machine.equipment_state_id === 1) {
                    hasState1 = true;
                }
                if (machine.equipment_state_id === 2) {
                    hasState2 = true;
                }
            });

            let finalEquipmentState = 3;
            if (hasState0) {
                finalEquipmentState = 0;
            }
            if (hasState1) {
                finalEquipmentState = 1;
            }
            if (hasState2) {
                finalEquipmentState = 2;
            }
            stationData.equipment_state_id = finalEquipmentState;
        },
        secondsToHumanTimeInLocale(seconds) {
            if ( !seconds || seconds <= 0 ) return '0s';

            const units = {
                day: 86400,
                hour: 3600,
                minute: 60,
                second: 1
            };

            let remainingSeconds = seconds;
            let timeString = '';

            for (let [unit, value] of Object.entries(units)) {
                const count = Math.floor(remainingSeconds / value);
                if (count > 0) {
                    const unitAbbr = unit.charAt(0);
                    timeString += `${count}${unitAbbr} `;
                    remainingSeconds %= value;
                }
            }

            return timeString.trim();
        },
        toggleTooltip() {
            this.showTooltip = !this.showTooltip;
        },
    },
    computed:{
        ...mapGetters('order_reference_view',['accordionCollapseStateById', 'accordionCollapseStates', 'rows', 'rowByKey', 'formattedRowInfo']),
        isStation(){
            return this.actualRow?.type == 'station';
        },
        isMachine(){
            return this.actualRow?.type == 'machine';
        },
        actualRow(){
            return this.rowByKey(this.row.key);
        },
        parentRow(){
            return this.rowByKey(this.row.parent_key);
        },
        stateClass(){
            let self = this;
            let state = '';
            switch(self.formattedRowInfo(self.row.key)?.state){
                case 0: state = 'stopped'; break;
                case 1: state = 'micro-stop'; break;
                case 2: state = 'working'; break;
                case 3: state = 'no-data'; break;
            }
            return state;
        },
        stateTitle(){
            let self = this;
            let descrip = '';
            switch(self.formattedRowInfo(self.row.key)?.state){
                case 0: descrip = 'EN PARADA'; break;
                case 1: descrip = 'EN MICROPARADA'; break;
                case 2: descrip = 'EN MARCHA'; break;
                case 3: descrip = 'ESPERANDO DATOS'; break;
            }
            return descrip;
        },
    },
    beforeMount(){
        this.prepareEchoListeners();
    }
}
</script>

<style lang="scss" scoped>
.station-row {
    background: #ececec;
    font-size: 1.1rem;
    font-weight: 400;
    td {
        &:nth-child(1) {
            width: 30px;
            div.clicable-relative {
                height: 30px;
                width: 30px;
                padding: 8px 0 8px 8px;
            }
        }
    }
}
.machines-row {

    td {
        color: rgb(83, 83, 83);
        &:nth-child(2) {
            padding: 0.5rem 0.5rem 0.5rem 1.5rem;
        }
        &:nth-child(1) {
            width: 30px;
            div.clicable-relative {
                height: 30px;
                width: 30px;
                padding: 8px 0 8px 8px;
            }
        }
    }
}
.clicable-relative {
    position: relative;
    cursor: pointer;
}
.state-tooltip {
    position: absolute;
    top: 0%;
    left: 0%;
    background-color: rgba(0, 0, 0, 0.85);
    color: #fff;
    padding: 8px 12px;
    border-radius: 6px;
    white-space: nowrap;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
    z-index: 10;
    font-size: 16px;
    line-height: 1;
    font-weight: 500;
}
.state-tooltip-row {
    display: flex;
    justify-content: center;
}
.state-tooltip-working{
    background: #4aa34a !important;
    color: white !important;
}
.state-tooltip-no-data {
    background-color: rgb(153, 153, 153) !important;
    color: white !important;
}
.state-tooltip-micro-stop {
    background-color: rgb(255, 209, 81) !important;
    color: black !important;
}
.state-tooltip-stopped {
    background-color: rgb(255, 0, 0) !important;
    color: white !important;
}
</style>